import { render, staticRenderFns } from "./CanteenCard.vue?vue&type=template&id=6c1fc300&"
import script from "./CanteenCard.vue?vue&type=script&lang=js&"
export * from "./CanteenCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports